import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { ProductItem } from 'src/app/api/models';
import { RegistryOfficesService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-ddt-subject',
  templateUrl: './modal-ddt-subject.component.html',
  styleUrls: ['./modal-ddt-subject.component.scss'],
})
export class ModalDdtSubjectComponent {
  question_title: string;

  frm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    maintenance: new FormControl(false),
  });

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private confirmationService: ConfirmationService
  ) {
    this.question_title = config.data!.question_title;
    if (config.data!.initial_value) {
      this.frm.get('name')!.setValue(config.data!.initial_value.name);
      this.frm.get('maintenance')!.setValue(config.data!.initial_value.maintenance);
    }
  }

  ngOnInit() {}

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({
      value: { name: this.frm.get('name')!.value, maintenance: this.frm.get('maintenance')!.value },
    });
  }
}
